import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid w-full grid-cols-3 items-center gap-4 mb-4" }
const _hoisted_2 = { class: "text-2xl col-start-1 col-end-2 font-semibold" }
const _hoisted_3 = { class: "text-2xl col-start-2 col-end-3 font-semibold" }
const _hoisted_4 = { class: "col-start-1 col-end-2 w-full" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "col-start-2 col-end-3 w-full" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { class: "flex gap-4 col-start-3 w-full" }
const _hoisted_9 = ["onClick"]

import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'multipleObjectInput',
  props: {
  initialValue: Array,
  objectKey: String,
  objectValue: String // Initial value for selected options, if any
},
  emits: ['updateSelectedOptions'],
  setup(__props, { emit: __emit }) {


const props = __props;

const emits = __emit;

const selectedOptions = ref(
  props.initialValue.length > 0
  ? props.initialValue.map(item => ({ name: item.name || '', capacity: item.capacity || '' }))
    : [{ name: '', capacity: '' }]
);

const addOption = () => {
  selectedOptions.value.push({name:"", capacity: ""})
  emitSelectedOptions();
};

const removeOption = (index: number) => {
  selectedOptions.value.splice(index, 1);
  emitSelectedOptions();
};

const emitSelectedOptions = () => {
  emits('updateSelectedOptions', selectedOptions.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.objectKey), 1),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.objectValue), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "Ünite adı",
              class: "w-full text-2xl px-2 py-3 outline-none",
              onInput: emitSelectedOptions,
              type: "text",
              "onUpdate:modelValue": ($event: any) => ((option.name) = $event)
            }, null, 40, _hoisted_5), [
              [_vModelText, option.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "Ünite Kapasitesi",
              class: "w-full text-2xl px-2 py-3 outline-none",
              onInput: emitSelectedOptions,
              type: "text",
              "onUpdate:modelValue": ($event: any) => ((option.capacity) = $event)
            }, null, 40, _hoisted_7), [
              [_vModelText, option.capacity]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (index === selectedOptions.value.length - 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ac-square-button !py-2 !px-4 h-full text-2xl !text-[var(--text-main-color)]",
                  onClick: addOption
                }, "+"))
              : _createCommentVNode("", true),
            (index > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "ac-square-button !py-2 !px-4 h-full text-2xl !text-[var(--text-main-color)]",
                  onClick: ($event: any) => (removeOption(index))
                }, "-", 8, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ], 64))
      }), 128))
    ])
  ]))
}
}

})